// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card__user-submission[data-v-f0ebdef8]{max-width:910px;margin:auto}.card__user-submission .btn.button__redeem-code[data-v-f0ebdef8]{padding:0;margin:0;text-align:start}.card__user-submission .btn-link.btn.button__redeem-code[data-v-f0ebdef8]{text-decoration:underline}.card__user-submission .btn-link.btn.button__redeem-code[data-v-f0ebdef8]:hover{text-decoration:none}.card__user-submission .select__submissions[data-v-f0ebdef8]{width:225px}", ""]);
// Exports
module.exports = exports;
